export default __webpack_public_path__ + "static/media/ca958939d092dcfe5eb2c7f6bbc115ab.b56d6731.svg";